import React from 'react';

import { openBilling, openReferEarn } from '../../utils/freeCreditsPrompts';

import { ActionButtonLabel } from './ActionBarActions';

const MORE_CREDIT_ITEMS = [
  { key: 'upgrade', label: 'Upgrade', icon: 'fa-solid fa-arrow-up', onClick: () => openBilling('plans') },
  { key: 'add-credits', label: 'Add credits', icon: 'fa-solid fa-coins', onClick: () => openBilling('credits') },
  { key: 'free-credits', label: 'Free credits', icon: 'fa-solid fa-gift', onClick: openReferEarn },
];

// Secondary placement keeps these inside More on every bar, never on the bar itself. The class names avoid
// --upgrade / --add-credit, which pin a credit gate's own buttons to the bar.
export const CreditMenuActions: React.FC = () => <>{MORE_CREDIT_ITEMS.map((item) => <button key={item.key} type="button"
  className={`ai-overview-action-btn ai-overview-action-btn--more-${item.key}`}
  data-action-key={`more-${item.key}`} data-action-placement="secondary" onClick={item.onClick}>
  <i className={item.icon} aria-hidden="true" />
  <ActionButtonLabel label={item.label} />
</button>)}</>;
